var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Rate',{staticClass:"pg-rate",attrs:{"count":_vm.count,"allowHalf":_vm.allowHalf,"disabled":_vm.disabled,"showText":_vm.showText,"clearable":_vm.clearable,"character":_vm.character,"icon":_vm.icon,"customIcon":_vm.customIcon,"value":_vm.val},on:{"on-change":_vm.onChange}},[_c('span',[_vm._v(_vm._s(_vm.valNum))])])
}
var staticRenderFns = []

export { render, staticRenderFns }